import { clearLocalStorageExceptTNX } from './utils/helpers';
import app from './app';

clearLocalStorageExceptTNX();

app.mount();
